export default __webpack_public_path__ + "static/media/sunburst.enabled.2ccac60d.png";